module.exports = __webpack_public_path__ + "static/img/图层 538.65e2e1bd.png";